import { render } from "./Age.vue?vue&type=template&id=5a6b800d"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"

import "./Age.vue?vue&type=style&index=0&id=5a6b800d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__